import cloneDeep from 'lodash-es/cloneDeep'

import { EmbroideryProviderEmbroideryVariantFieldsFragment } from '../../../__generated__/graphql/catalog/graphql'
import { formatPrettyCurrency } from '../../../lib/utils/currency'
import { isLegacyEmbroideryVariant } from '../useEmbroideryVariants'

export function getEmbroideryPriceRange({
  embroideryVariants,
  relatedSetupVariant,
  locale,
}: {
  embroideryVariants: readonly EmbroideryProviderEmbroideryVariantFieldsFragment[]
  relatedSetupVariant: EmbroideryProviderEmbroideryVariantFieldsFragment | undefined
  locale: Parameters<typeof formatPrettyCurrency>[0]['locale']
}) {
  // The range is legacy's, so products only the multi-placement flow sells stay out of it.
  const allEmbroideryOptionPrices = embroideryVariants
    .filter(isLegacyEmbroideryVariant)
    .map(embroideryVariant => embroideryVariant.productInfo.price)

  if (allEmbroideryOptionPrices.length === 0) return undefined

  const lowestPrice = allEmbroideryOptionPrices.reduce((lowest, current) => {
    return lowest.amount < current.amount ? lowest : current
  })
  const highestPrice = cloneDeep(
    allEmbroideryOptionPrices.reduce((lowest, current) => {
      return lowest.amount > current.amount ? lowest : current
    })
  )
  if (relatedSetupVariant) highestPrice.amount += relatedSetupVariant.productInfo.price.amount

  const effectivePrice = cloneDeep(lowestPrice)
  if (relatedSetupVariant) effectivePrice.amount += relatedSetupVariant.productInfo.price.amount

  return {
    min: {
      ...lowestPrice,
      displayValue: formatPrettyCurrency({
        value: lowestPrice.amount,
        unit: 'dollars',
        currency: lowestPrice.currencyCode,
        locale,
      }),
    },
    max: {
      ...highestPrice,
      displayValue: formatPrettyCurrency({
        value: highestPrice.amount,
        unit: 'dollars',
        currency: highestPrice.currencyCode,
        locale,
      }),
    },
    effectivePrice: {
      ...effectivePrice,
      displayValue: formatPrettyCurrency({
        value: effectivePrice.amount,
        unit: 'dollars',
        currency: effectivePrice.currencyCode,
        locale,
      }),
    },
  }
}
